import { useCallback, useMemo } from 'react'
import { aktiveSprache, text, type OberflaechenSprache } from '../lib/oberflaeche'
import type { TextSchluessel } from '../i18n/de'

/** Aktive Sprache der Oberfläche (Gerät oder gespeicherte Wahl). */
export function useOberflaechenSprache(): OberflaechenSprache {
  return useMemo(() => aktiveSprache(), [])
}

/** `t('anmeldung.absenden')` in der aktiven Sprache. */
export function useT(): (schluessel: TextSchluessel, werte?: Record<string, string | number>) => string {
  const sprache = useOberflaechenSprache()
  return useCallback((schluessel, werte) => text(sprache, schluessel, werte), [sprache])
}
